import React, { memo } from "react";
import PropTypes from "prop-types";
import { styled } from "@washingtonpost/wpds-ui-kit";

const HeadlineOverlay = styled("div", {
  position: "absolute",
  left: 0,
  right: 0,
  display: "flex",
  textAlign: "left",
  opacity: 1,
  variants: {
    isVertical: {
      true: {
        bottom: "100px"
      },
      false: {
        bottom: "-80px"
      }
    }
  },
  defaultVariants: {
    isVertical: true
  }
});

const ControlsHeadline = styled("p", {
  color: "$gray700",
  fontFamily: "$headline",
  fontSize: "$125"
});

/**
 * The Headline component is used to display the headline of the video.
 */
const Headline = props => {
  const { headline, isVertical = true } = props;

  return (
    <HeadlineOverlay isVertical={isVertical} data-testid="headline">
      <ControlsHeadline isVertical={isVertical}>{headline}</ControlsHeadline>
    </HeadlineOverlay>
  );
};

Headline.propTypes = {
  /** The headline currently being displayed. */
  headline: PropTypes.string.isRequired,
  /** When false, uses compact placement for landscape carousel players. */
  isVertical: PropTypes.bool
};

Headline.displayName = "Headline";

export default memo(Headline);
